export function formatNumber(n, fixed = 0) {
  if (!Number.isNaN(n) && n != null) {
    return Number(n)
      .toFixed(fixed)
      .replace(/./g, (c, i, a) => (i && c !== ',' && (a.length - i) % 3 === 0 ? `,${c}` : c))
      .replace(',.', '.');
  }
  return 0;
}

export function formatNumberWithCommas(n, fixed = 0) {
  if (!Number.isNaN(n) && n != null) {
    return n
      .toFixed(fixed)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  return 0;
}

export function formatDate(d) {
  const options = {
    year: '2-digit',
    month: 'numeric',
    day: 'numeric',
  };
  const date = new Date(d);
  return date.toLocaleDateString('fr-FR', options);
}

export function snakeToCamel(str) {
  return str.replace(/([-_][a-z])/g, group => group.toUpperCase().replace('-', '').replace('_', ''));
}
